import { useTranslation } from 'react-i18next';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

import { Translate } from 'components/Translate/Translate';

import { LoginState } from '../contexts/LoginStateContext/LoginStateContext';
import { LoginStateProvider } from '../contexts/LoginStateContext/LoginStateProvider';
import { useLoginState } from '../contexts/LoginStateContext/useLoginState';
import { AuthBodySection } from '../components/AuthBodySection/AuthBodySection';
import { AuthPage } from '../components/AuthPage/AuthPage';
import { PasswordlessLoginForm } from '../components/PasswordlessLoginForm/PasswordlessLoginForm';
import { PasswordlessSuccess } from '../components/PasswordlessSuccess/PasswordlessSuccess';

export const ExpiredLink = () => {
  return (
    <LoginStateProvider>
      <AuthPage>
        <ExpiredMagicLinkForm />
      </AuthPage>
    </LoginStateProvider>
  );
};

const ExpiredMagicLinkForm = () => {
  const { t } = useTranslation();
  const { loginState } = useLoginState();

  if (loginState === LoginState.passwordlessSuccess) {
    return (
      <AuthBodySection heading={t('auth:heading.passwordlessSuccess')}>
        <div className="w-min self-center rounded-full bg-procuros-grey p-4 text-slate-900">
          <EnvelopeIcon className="size-8" />
        </div>
        <PasswordlessSuccess
          passwordlessOnly
          confirmationText={t('auth:body.passwordlessSuccessConfirmation')}
          nextStepsText={t('auth:body.passwordlessSuccessNextSteps')}
        />
      </AuthBodySection>
    );
  }

  return (
    <AuthBodySection heading={t('auth:heading.passwordlessExpired')}>
      <p className="text-sm text-gray-900">
        <Translate i18nKey="auth:body.passwordlessExpired" />
      </p>
      <PasswordlessLoginForm passwordlessOnly previousUrl={window.location.href} />
    </AuthBodySection>
  );
};
